import type { WhatsappChat } from "../../types.ts";

export function chatBadge(chats: WhatsappChat[]): string | null {
  const unread = chats.reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
  return countBadge(unread);
}

export function countBadge(count: number): string | null {
  if (count <= 0) return null;
  return count > 99 ? "99+" : String(count);
}
